<template>
  <div
    class="page-action-bar mb-4"
    role="group"
    aria-label="Ações da página"
  >
    <slot />
    <v-btn
      v-for="(item, index) in items"
      :key="item.id != null ? item.id : index"
      class="page-action-bar__button mb-2"
      :color="isHighlighted(item) ? 'info' : 'grey'"
      :outlined="!isHighlighted(item)"
      :disabled="disabled || item.disabled"
      @click="$emit('action', item)"
    >
      <v-icon
        v-if="item.icon"
        left
        small
      >
        {{ item.icon }}
      </v-icon>
      {{ item.title }}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'PageActionBar',
    props: {
      items: { type: Array, default: () => [] },
      disabled: { type: Boolean, default: false },
    },
    methods: {
      isHighlighted (item) {
        return item.primary === true || /transmitir documentos ao contador/i.test(item.title || '')
      },
    },
  }
</script>

<style scoped>
.page-action-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.page-action-bar__button {
  margin: 0 !important;
  min-height: 36px;
  text-transform: none;
  letter-spacing: normal;
}
@media (max-width: 600px) {
  .page-action-bar {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    justify-content: stretch;
    gap: 8px;
    margin-top: 12px;
    margin-bottom: 16px !important;
  }
  .page-action-bar__button,
  .page-action-bar ::v-deep > .v-btn {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100%;
    min-height: 42px;
    height: auto !important;
    margin: 0 !important;
    padding: 9px 12px !important;
    white-space: normal;
    justify-content: flex-start;
    text-align: left;
    line-height: 1.35;
  }
  .page-action-bar__button ::v-deep .v-btn__content {
    white-space: normal;
    text-align: left;
  }
}
</style>
